// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jrpw557G {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2000;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 1rem;
}
@media (max-width: 767px) {
  .jrpw557G {
    padding: 1rem;
  }
}
.yuTHIwBs {
  position: relative;
  background: #ffffff;
  border-radius: 0.75rem;
  max-width: 25rem;
  width: 100%;
  padding: 3rem 1.5rem 2rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  -webkit-animation: eyur50t1 0.3s ease;
          animation: eyur50t1 0.3s ease;
}
@media (max-width: 767px) {
  .yuTHIwBs {
    max-width: 90%;
    padding: 2rem 1rem 1.5rem;
  }
}
@-webkit-keyframes eyur50t1 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes eyur50t1 {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.rD7hWlHf {
  font-size: 1.5rem;
  font-weight: bold;
  color: #585858;
  text-align: center;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .rD7hWlHf {
    font-size: 1.25rem;
  }
}
.fviUVfxN {
  font-size: 0.875rem;
  color: #585858;
  text-align: center;
  margin: 0 0 1rem 0;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .fviUVfxN {
    font-size: 0.75rem;
  }
}
.Wh_cJu2W {
  font-size: 1.125rem;
  font-weight: bold;
  color: #585858;
  text-align: center;
  margin: 0 0 2rem 0;
  word-break: break-all;
  padding: 0;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .Wh_cJu2W {
    font-size: 1rem;
  }
}
.M2pFV8EJ {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  gap: 1rem;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
          justify-content: space-between;
}
@media (max-width: 767px) {
  .M2pFV8EJ {
    gap: 0.5rem;
    width: 80%;
    margin: 0 auto;
  }
}
.nJ12kJS3 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  padding: 1rem;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 999px;
  color: #585858;
  font-size: 1rem;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
  font-weight: normal;
}
.nJ12kJS3:hover {
  background: #f5f5f5;
}
.nJ12kJS3:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .nJ12kJS3 {
    font-size: 0.875rem;
    padding: 0.5rem;
  }
}
.aZcSH689 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
          flex: 1;
  padding: 1rem;
  background: #626cda;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  min-height: 2.75rem;
  min-width: 2.75rem;
}
.aZcSH689:hover {
  background: #3945d0;
}
.aZcSH689:active {
  -webkit-transform: scale(0.98);
          transform: scale(0.98);
}
@media (max-width: 767px) {
  .aZcSH689 {
    font-size: 0.875rem;
    padding: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SupportModal/SupportModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECkBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDlBA,aAAA;AAAF;ACTE;EAAA;IDYE,aAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;EACA,qCAAA;UAAA,6BAAA;AAAF;ACxBE;EAAA;ID2BE,cAAA;IACA,yBAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AARA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AChDE;EAAA;IDoDE,kBAAA;EAAF;AACF;AAGA;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AC5DE;EAAA;IDgEE,kBAAA;EAAF;AACF;AAGA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AADF;AC3EE;EAAA;ID+EE,eAAA;EAAF;AACF;AAGA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,SAAA;EACA,yBAAA;EAAA,sCAAA;UAAA,8BAAA;AADF;ACrFE;EAAA;IDyFE,WAAA;IACA,UAAA;IACA,cAAA;EAAF;AACF;AAGA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;ECzBA,mBAAA;EACA,kBAAA;ED0BA,mBAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,8BAAA;UAAA,sBAAA;AADJ;AChHE;EAAA;IDqHE,mBAAA;IACA,eAAA;EADF;AACF;AAIA;EACE,mBAAA;EAAA,eAAA;UAAA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;ECrDA,mBAAA;EACA,kBAAA;ADoDF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,8BAAA;UAAA,sBAAA;AAFJ;AC1IE;EAAA;IDgJE,mBAAA;IACA,eAAA;EAFF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px); // 背景模糊效果\n  z-index: @z-index-modal;\n  .flex-center();\n  padding: @spacing-md;\n\n  .mobile({\n    padding: @spacing-md;\n  });\n}\n\n.modal {\n  position: relative;\n  background: @white;\n  border-radius: @border-radius-lg;\n  max-width: 25rem; // 400px\n  width: 100%;\n  padding: @spacing-xxl @spacing-lg @spacing-xl;\n  box-shadow: @box-shadow-lg;\n  animation: slideUp 0.3s ease;\n\n  .mobile({\n    max-width: 90%;\n    padding: @spacing-xl @spacing-md @spacing-lg;\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem); // 20px\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.title {\n  font-size: @font-size-xxl;\n  font-weight: bold;\n  color: @text-color;\n  text-align: center;\n  margin: 0 0 @spacing-md 0;\n  line-height: 1.4;\n\n  .mobile({\n    font-size: @font-size-xl;\n  });\n}\n\n.description {\n  font-size: @font-size-sm;\n  color: @text-color; // 黑色，不是灰色\n  text-align: center;\n  margin: 0 0 @spacing-md 0;\n  line-height: 1.5;\n\n  .mobile({\n    font-size: @font-size-xs;\n  });\n}\n\n.email {\n  font-size: @font-size-lg;\n  font-weight: bold;\n  color: @text-color;\n  text-align: center;\n  margin: 0 0 @spacing-xl 0;\n  word-break: break-all;\n  padding: 0;\n  line-height: 1.5;\n\n  .mobile({\n    font-size: @font-size-md;\n  });\n}\n\n.actions {\n  display: flex;\n  gap: @spacing-md;\n  justify-content: space-between;\n\n  .mobile({\n    gap: @spacing-sm;\n    width: 80%;\n    margin: 0 auto;\n  });\n}\n\n.cancelButton {\n  flex: 1;\n  padding: @spacing-md;\n  background: @white;\n  border: 1px solid @border-color;\n  border-radius: 999px; // 椭圆形状的圆角\n  color: @text-color; // 黑色文字，不是灰色\n  font-size: @font-size-md;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n  font-weight: normal;\n\n  &:hover {\n    background: @background-color;\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-sm;\n    padding: @spacing-sm;\n  });\n}\n\n.copyButton {\n  flex: 1;\n  padding: @spacing-md;\n  background: #626cda;\n  border: none;\n  border-radius: 999px; // 椭圆形状的圆角\n  color: @white;\n  font-size: @font-size-md;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  .touch-friendly();\n\n  &:hover {\n    background: darken(#626cda, 10%);\n  }\n\n  &:active {\n    transform: scale(0.98);\n  }\n\n  .mobile({\n    font-size: @font-size-sm;\n    padding: @spacing-sm;\n  });\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `jrpw557G`,
	"modal": `yuTHIwBs`,
	"slideUp": `eyur50t1`,
	"title": `rD7hWlHf`,
	"description": `fviUVfxN`,
	"email": `Wh_cJu2W`,
	"actions": `M2pFV8EJ`,
	"cancelButton": `nJ12kJS3`,
	"copyButton": `aZcSH689`
};
export default ___CSS_LOADER_EXPORT___;
